// @ts-nocheck

export const DE_GAIN_TAX_RATIO = 0.053;
